import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fleet-managed-badge",
  "data-testid": "fleet-managed-badge"
}

import { computed } from 'vue';
import { FLEET } from '@shell/config/labels-annotations';


export default /*@__PURE__*/_defineComponent({
  __name: 'FleetManagedBadge',
  props: {
    resource: {}
  },
  setup(__props: any) {

const props = __props;

const isFleetManaged = computed(() => !!props.resource?.metadata?.labels?.[FLEET.MANAGED_BY_KIND]);

return (_ctx: any,_cache: any) => {
  return (isFleetManaged.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", {
          class: "icon icon-fleet-alt mr-5",
          "aria-hidden": "true"
        }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.t('resourceDetail.masthead.fleetManagedBadge')), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})